<template>
    <div class="closing-part">
        <div class="signatures">
            <div class="input-container date-input">
                <input id="report-date" v-model="reportDateInput" maxlength="50" />
                <label for="report-date"><i class="fa fa-pencil"></i></label>
            </div>

            <div class="input-container sign-input">
                <input id="report-signature" v-model="reportSignatureInput" maxlength="50" />
                <label for="report-signature"><i class="fa fa-pencil"></i></label>
            </div>

            <p class="date">{{ $translate('date') }}</p>
            <p class="sign">{{ $translate('signature') }}</p>
        </div>

        <about-chloe v-if="!isFdaFriendly" />
    </div>
</template>

<script>
import moment from 'moment'
import AboutChloe from '../AboutChloe'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'ClosingPart',
    components: { AboutChloe },
    data: () => ({
        reportDateInput: '',
        reportSignatureInput: ''
    }),
    computed: {
        ...mapState({
            locale: state => state.locale.locale
        }),
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        })
    },
    mounted() {
        this.reportDateInput = moment().locale(this.locale.code).format('DD MMM YYYY').toUpperCase()
    }
}
</script>

<style lang="scss" scoped>
$active: $light-3;
$passive: $light;

.closing-part {
    height: 100%;
    display: flex;
    flex-direction: column;

    .signatures {
        margin-top: auto;
        display: grid;
        grid-template-columns: repeat(2, 280px);
        justify-items: center;
        justify-content: space-around;

        .input-container {
            width: 100%;

            input {
                background-color: transparent;
                border: none;
                text-align: center;

                &::-webkit-input-placeholder {
                    @media screen {
                        color: $passive;
                    }
                    @media print {
                        color: transparent;
                    }
                }

                @media screen {
                    width: calc(100% - 18px);
                    color: $active;

                    &:focus ~ label {
                        color: $active;
                    }
                }
                @media print {
                    width: 100%;
                    color: black;
                }
            }

            label {
                @media screen {
                    color: $passive;
                    cursor: pointer;
                    margin-bottom: 0;

                    &:hover {
                        color: $active;
                    }
                }
                @media print {
                    display: none;
                }
            }
        }

        .date,
        .sign {
            width: 100%;
            padding: 10px;
            text-align: center;

            @media screen {
                border-top: solid 1px $light-3;
            }
            @media print {
                border-top: solid 1px black;
            }
        }
    }
}
</style>
